import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useLocation } from "react-router";
import { AddButton } from "../../../utils/commonComponent/Custom/Button";


const StatusExcelDownload = ({
  finalData,
  notNeededColumn, 
  headers,
  secondTable,
  thirdTable,
}) => {

  const location = useLocation();
  const routeSegments = location.pathname.split("/");
  const selectedRouteInUpperCase = (
    routeSegments[1] === "master" ? routeSegments[2] : routeSegments[1]
  )
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase());

  const convertToExcel = () => {
    const dataWithoutNotNeededKeys =
      notNeededColumn.length > 0
        ? finalData.map((item) => {
          const filteredItem = {};
          for (const key in item) {
            if (item.hasOwnProperty(key) && !notNeededColumn.includes(key)) {
              let value = item[key];

              if (Array.isArray(value)) {
                value = value.join(", ");
              }

              filteredItem[key] = shouldConvertToDate(key)
                ? value
                  ? new Date(value).toLocaleDateString("en-GB")
                  : ""
                : value;
            }
          }
          return filteredItem;
        })
        : finalData;

    const headersMap = headers?.reduce((acc, { key, label }) => {
      acc[key] = label;
      return acc;
    }, {});

    const transformedData = dataWithoutNotNeededKeys.map((item) => {
      const newItem = {};
      for (const key in item) {
        newItem[headersMap?.[key] || key] = item[key];
      }
      return newItem;
    });

    const workbook = XLSX.utils.book_new();
    const worksheet1 = XLSX.utils.json_to_sheet(transformedData);

    // ==============================
    // 🔹 Dynamic Count Calculation
    // ==============================

    const preparedCount = finalData.filter(
      (row) => row.testedBy_userName && row.testedBy_userName !== "-"
    ).length;

    const reviewedCount = finalData.filter(
      (row) => row.reviewedBy_userName && row.reviewedBy_userName !== "-"
    ).length;

    const authorizedCount = finalData.filter(
      (row) => row.authorizedBy_userName && row.authorizedBy_userName !== "-"
    ).length;

    const reviewedCompleted = reviewedCount;
    const reviewedPending = finalData.length - reviewedCompleted;

    const authorizedCompleted = authorizedCount;
    const authorizedPending = finalData.length - authorizedCompleted;

    // ==============================
    // 🔹 Add 3 Empty Rows
    // ==============================

    XLSX.utils.sheet_add_json(worksheet1, [{}], {
      skipHeader: true,
      origin: -1,
    });
    XLSX.utils.sheet_add_json(worksheet1, [{}], {
      skipHeader: true,
      origin: -1,
    });
    XLSX.utils.sheet_add_json(worksheet1, [{}], {
      skipHeader: true,
      origin: -1,
    });

    // ==============================
    // 🔹 Summary Data
    // ==============================

    const summaryData = [
      { Summary: "Tested By", Count: preparedCount },
      { Summary: "Reviewed By", Count: reviewedCount },
      { Summary: "Authorized By", Count: authorizedCount },
      {},
      { Summary: "Reviewed Completed", Count: reviewedCompleted },
      { Summary: "Reviewed Pending", Count: reviewedPending },
      {},
      { Summary: "Authorized Completed", Count: authorizedCompleted },
      { Summary: "Authorized Pending", Count: authorizedPending },
    ];

    // Append summary
    // XLSX.utils.sheet_add_json(worksheet1, summaryData, {
    //   skipHeader: true,
    //   origin: -1,
    // });
    XLSX.utils.book_append_sheet(workbook, worksheet1, "Sheet1");

    if (secondTable?.length > 0) {
      const worksheet2 = XLSX.utils.json_to_sheet(secondTable);
      XLSX.utils.book_append_sheet(workbook, worksheet2, "Sheet2");
    }

    if (thirdTable?.length > 0) {
      const worksheet3 = XLSX.utils.json_to_sheet(thirdTable);
      XLSX.utils.sheet_add_json(worksheet3, [{}], {
        skipHeader: true,
        origin: thirdTable.length + 1,
      });
      XLSX.utils.book_append_sheet(workbook, worksheet3, "Sheet3");
    }

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(data, `${selectedRouteInUpperCase || "data"}.xlsx`);
  };

  function shouldConvertToDate(key) {
    const dateKeys = [
      "checkinDatetime",
      "checkoutDatetime",
      "lastModified",
      "outwardDate",
      "expectedReturnDate",
      "returnDate",
      "siteInwardDate",
      "dateOfBirth",
      "dateOfJoining",
    ];
    return dateKeys.includes(key);
  }

  return (
    <div>
      <AddButton
        id="btn-add-outline"
        label="Export Excel"
        onClick={convertToExcel}
      />
    </div>
  );
};

export default StatusExcelDownload;
